import clsx from "clsx"

export const MultilineTextAttribute = ({
    value,
    required,
    placeholder,
    readOnly,
    className,
    onChange,
    onBlur,
}: {
    value?: string,
    required?: boolean,
    placeholder?: string,
    readOnly?: boolean,
    className?: string,
    onChange: (value: any) => void,
    onBlur: () => void
}) => {
    return <>
        <textarea
            required={required}
            placeholder={placeholder}
            readOnly={readOnly}
            rows={2}
            value={value || ''}
            onBlur={() => onBlur()}
            onChange={(e) => onChange(e.target.value)}
            className={clsx(className, 'form-control form-control-sm')} />
    </>
}
